import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { PageTypeEnum } from 'common/enums/PageTypeEnum'
import { EntitiesStructure } from 'common/types/Page'
import {
  findEntityByType,
  getEntityExistingChildIds,
} from 'common/utils/entityUtils'
import { WebsiteLibraryElementsCreator } from 'src/editor/pages/website/website-library-elements-creator'
import { LibraryElementEnum } from 'src/shared/enums/LibraryElementEnum'
import { EntityWithChildIdsNewInterface } from 'src/shared/schemas/entity.schema'
import ServerPageInterface from 'src/shared/types/server-page-interface'
import { WebsitePageInterface } from 'src/shared/types/website-entities'

// NOTE: for https://app.shortcut.com/systeme/story/86891/support-section-entity-for-website-pages-websitepagebody
export default function addSectionToWebsitePageCommand(
  page: ServerPageInterface,
): [ServerPageInterface, boolean] {
  if (
    [
      PageTypeEnum.WebsiteHome,
      PageTypeEnum.WebsiteDefault,
      PageTypeEnum.WebsitePricing,
    ].includes(page.type)
  ) {
    const entities = page.content.entities as EntitiesStructure

    const websitePageBody = findEntityByType(
      entities,
      EntityTypeEnum.WebsitePageBody,
    ) as WebsitePageInterface

    const websitePageBodyChildIds = getEntityExistingChildIds(
      entities,
      websitePageBody,
    )
    if (websitePageBodyChildIds.length) {
      const websitePageBodyChildren = entities[websitePageBodyChildIds[0]]
      if (websitePageBodyChildren.type !== EntityTypeEnum.Section) {
        const section = new WebsiteLibraryElementsCreator()[
          LibraryElementEnum.LibrarySection
        ](websitePageBody.id)
        websitePageBody.childIds = [section.id]
        entities[section.id] = section

        for (const childId of websitePageBodyChildIds) {
          const child = entities[childId] as EntityWithChildIdsNewInterface
          child.parentId = section.id
          section.childIds.push(childId)
        }

        return [page, true]
      }
    }
  }

  return [page, false]
}
